var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWoopLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 290 96"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#woop_logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M49.702 96H81.23l37.999-68.16L157.778 96h31.528l49.426-96h-35.245l-31.666 62.674L135.612 0H103.12L68.563 64.183 35.658 0H0l49.702 96zm237.957-30.171L290 0h-34.97l2.34 65.829h30.289z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6CBBED",
  d: "M289.725 96h-34.42V73.508h34.42V96z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "woop_logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h290v96H0z"
})))));
export default SvgWoopLogo;